"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import { toEcommerceProduct, trackProductClicked } from "@/lib/analytics/segment";
import type { ProductHit } from "@/lib/search/types";
import { useSearchPanelStore } from "@/stores/useSearchPanelStore";
import { MatchedAttributesBadges } from "./MatchedAttributesBadges";
interface Props {
  hit: Pick<ProductHit, "sku" | "slug" | "name" | "displayName" | "description" | "imageUrl" | "imageAlt" | "matchedAttributes" | "startingPrice" | "category">;
  // 0-based index from SearchProductHitList; converted to the 1-based Segment
  // ecommerce `position` at the click site.
  position: number;
}
export function SearchProductHit(t0) {
  const $ = _c(23);
  const {
    hit,
    position
  } = t0;
  const close = useSearchPanelStore(_temp);
  const title = hit.displayName || hit.name;
  const t1 = `/${hit.slug}`;
  let t2;
  if ($[0] !== close || $[1] !== hit || $[2] !== position) {
    t2 = () => {
      trackProductClicked(toEcommerceProduct(hit, position + 1));
      close();
    };
    $[0] = close;
    $[1] = hit;
    $[2] = position;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== hit.imageAlt || $[5] !== hit.imageUrl || $[6] !== title) {
    t3 = hit.imageUrl && <div className="relative aspect-square w-16 shrink-0 self-start"><Image src={hit.imageUrl} alt={hit.imageAlt ?? title} fill={true} sizes="64px" className="rounded-md object-contain" /></div>;
    $[4] = hit.imageAlt;
    $[5] = hit.imageUrl;
    $[6] = title;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== title) {
    t4 = <p className="text-sm font-semibold leading-tight text-foreground">{title}</p>;
    $[8] = title;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== hit.description) {
    t5 = hit.description && <p className="line-clamp-2 text-xs leading-snug text-muted-foreground">{hit.description}</p>;
    $[10] = hit.description;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== hit.matchedAttributes) {
    t6 = <MatchedAttributesBadges attrs={hit.matchedAttributes} />;
    $[12] = hit.matchedAttributes;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t4 || $[15] !== t5 || $[16] !== t6) {
    t7 = <div className="flex min-w-0 flex-1 flex-col gap-1">{t4}{t5}{t6}</div>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t7) {
    t8 = <Link href={t1} onClick={t2} className="flex items-stretch gap-3 rounded-md py-3 font-normal no-underline! hover:opacity-100!">{t3}{t7}</Link>;
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}
function _temp(state) {
  return state.close;
}